import React from 'react';
import classnames from 'classnames';
import styles from './RegFormsContainer.module.scss';

export interface RegFormsContainerProps {
  children: React.ReactNode,
  className?: string,
}

const RegFormsContainer = ({className, children}: RegFormsContainerProps) => {

  return (
    <div
      className={classnames(styles.regFormsContainer, className)}
    >
      {children}
    </div>
  );
};

export default RegFormsContainer;
